import DuplicateTemplateMessage from "@features/ux/components/shared/components/duplicateMessage";
import SendCommunication from "@features/ux/components/shared/components/sendCommuication";
import { Button } from "@shared/ui/button";
import { Copy, Plus, Send, SquarePenIcon } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useCreateDuplicateRecipientList } from "../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

// In QuickAction.tsx

const QuickAction = ({ data }: { data: any }) => {
  const { id, name } = useParams();
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();
  const createDuplicateRecipientList = useCreateDuplicateRecipientList();
  const [openDuplicateTemplateMessage, setOpenDuplicateTemplateMessage] =
    useState(false);
  const [newTemplateName, setNewTemplateName] = useState(""); // Add this state here

  const handleDuplicateRecipientList = () => {
    const payload = {
      remote_utility_id: remoteUtilityId,
      list_id: id, // Use id from params, not the parameter
      name: newTemplateName, // Use the new name from state
    };
    createDuplicateRecipientList.mutate(payload);
    setNewTemplateName(""); // Reset after mutation
    setOpenDuplicateTemplateMessage(false); // Close dialog
  };

  return (
    <div>
      <div>
        <h2 className="text-md font-semibold">Quick Actions</h2>
      </div>
      <div className="flex flex-col gap-2 mt-4">
        <Button
          variant="default"
          onClick={() =>
            navigate(
              `/communication-hub/quick-message?tab=bulkMessage&recipientType=${data?.audienceType}&recipientList=${data?.id}`
            )
          }
        >
          <Send className="mr-2 h-4 w-4" /> Send Communication
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/communication-hub/workflows/create")}
        >
          <Plus className="mr-2 h-4 w-4" /> Create Workflow
        </Button>
        <Button
          variant="outline"
          onClick={() =>
            navigate(`/communication-hub/recipient-list/edit/${id}/${name}`)
          }
        >
          <SquarePenIcon className="mr-2 h-4 w-4" /> Edit List
        </Button>
        <Button
          variant="outline"
          onClick={() => setOpenDuplicateTemplateMessage(true)}
        >
          <Copy className="mr-2 h-4 w-4" /> Duplicate List
        </Button>
      </div>

      {/* Duplicate Recipient List */}
      <DuplicateTemplateMessage
        open={openDuplicateTemplateMessage}
        onOpenChange={setOpenDuplicateTemplateMessage}
        templateName={name || ""}
        templateId={id}
        actiontype="recipientList"
        onDuplicate={handleDuplicateRecipientList}
        newTemplateName={newTemplateName}
        setNewTemplateName={setNewTemplateName}
        customDescription={`Are you sure you want to duplicate the recipient list "${name}"? A copy will be created with all recipients.`}
        customInfoItems={[
          "A new recipient list will be created with all recipients copied",
          'The duplicate will have "(Copy)" appended to its name',
          "You can modify the duplicate independently from the original",
          "All recipient filters and segments will be preserved",
        ]}
      />
    </div>
  );
};

export default QuickAction;

